import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.024 7.672C5.11 9.072 5 10.602 5 11v8h14v-8c0-.398-.11-1.929-1.024-3.328C17.108 6.345 15.432 5 12 5S6.892 6.345 6.024 7.672M4.35 6.578C5.608 4.655 7.932 3 12 3s6.392 1.655 7.65 3.578C20.86 8.428 21 10.398 21 11v8.003A2 2 0 0 1 19 21H5c-1.101 0-2-.89-2-1.998V11c0-.602.14-2.571 1.35-4.422",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7 12a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1zm8 0H9v1h6zm-6 4v-1h6v1zm0 2v1h6v-1z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }